@if (value) {
  <div class="empty-state">
    {{value}}
  </div>
}